<template>
  <b-card
    v-show="!errorContent.table"
    no-body
    class="mb-0 p-3"
  >
    <b-card-body>
      <b-card-title>
        <feather-icon
          icon="FileTextIcon"
          size="30"
          class="mr-0 mr-sm-50"
        /> Lista de Alumnos con Posible Baja Académica - Inactividad
      </b-card-title>
    </b-card-body>

    <!-- Datos cargados -->
    <b-card-header class="pb-0">
      <b-card-title />
      <b-card-text class="font-small-2 mr-25 mb-0">
        Datos cargados. <b>{{ updatedAt }}</b>
      </b-card-text>
    </b-card-header>

    <!-- Table Top -->
    <div class="m-2">
      <b-row>
        <!-- Cantidad de elementos por página -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <span>Mostrar</span>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
          />
        </b-col>

        <!-- Buscador -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon
                  :class="{ 'text-danger cursor-pointer': searchQuery != '' }"
                  :icon="searchQuery != '' ? 'XIcon' : 'SearchIcon'"
                  @click="searchQuery != '' ? searchQuery = '' : ''"
                />
              </b-input-group-prepend>
              <b-form-input
                v-model="searchQuery"
                placeholder="Buscar"
              />
            </b-input-group>
          </div>
        </b-col>
      </b-row>
    </div>
    <p class="mb-0 mt-1">
      <small>La lista mostrada son de alumnos no egresados, activos, que no tienen materias en curso y de cualquier especialidad.</small>
    </p>
    <p class="m-0">
      <small>Son alumnos que ya no tienen agenda en los periodos posteriores a su último periodo cursado, considerando los status "Al Corriente", 'Sin Especificar' y 'No aprobado'.</small>
    </p>
    <p class="mt-0 mb-2">
      <small>Son candidatos para bajas académicas; se respetan las calificaciones en kardex.</small>
    </p>
    <b-overlay
      rounded="sm"
      :show="isBusyTable"
      opacity="0"
    >
      <b-table
        ref="refDataListTable"
        class="position-relative"
        empty-text="No se encontraron resultados"
        primary-key="id_table_alu_pos_baja"
        responsive
        show-empty
        striped
        :items="fetchData"
        :fields="tableColumns"
        :sort-desc.sync="isSortDirDesc"
        :sort-by.sync="sortBy"
      >
        <template #cell(nombre)="data">
          <b-media vertical-align="center">
            <template>
              <b-avatar
                size="42"
                :text="avatarText(data.item.nombre)"
                :variant="`light-${resolveAlumnoTipoVariant(data.item.solicitud)}`"
              />
              <small><b>{{ data.item.nombre }} {{ data.item.segundoNombre }} {{ data.item.apellidoPaterno }} {{ data.item.apellidoMaterno }}</b></small>
              <p class="m-0">
                <small>Matricula: <b>{{ data.item.matricula }} </b></small>
              </p>
              <p class="m-0">
                <small>{{ data.item.email }} </small>
              </p>
              <p class="m-0">
                <small>{{ data.item.emailAlt }} </small>
              </p>
              <p class="m-0">
                <small>Tel: {{ data.item.telefono1 }} </small>
              </p>
            </template>
          </b-media>
        </template>
        <template #cell(descripcion)="data">
          <b-media vertical-align="center">
            <template>
              <p class="m-0">
                <small> Plan de estudios : {{ data.item.nombre_plan }}</small>
              </p>
              <p class="m-0">
                <small> Generación : <b>{{ data.item.generacion_agenda }}</b></small>
              </p>
              <p class="m-0">
                <small> Último periodo cursado: <b>{{ data.item.ultimo_periodo }}</b></small>
              </p>
              <p class="m-0">
                <small> Total de agendas : <b>{{ data.item.numeroagendas }} </b> </small>
              </p>
              <p class="m-0">
                <small> Último status académico: <b>{{ data.item.descripcion }}</b></small>
              </p>
            </template>
          </b-media>
        </template>
        <template
          #cell(opciones)="data"
        >
          <div
            class="text-nowrap text-center"
          >
            <!-- Detalle -->
            <b-button
              :id="`usuario-row-${data.index}-ver-icon`"
              :variant="`outline-${resolveAlumnoTipoVariant(data.item.solicitud)}`"
              @click="crearsolicitud(data)"
            >
              <feather-icon
                icon="PlusIcon"
                class="cursor-pointer mr-1"
              /> Crear solicitud
            </b-button>
          </div>
        </template>
      </b-table>
    </b-overlay>
    <!-- Table's footer & pagination -->
    <div class="mx-2 mb-2">
      <b-row>
        <!-- Leyenda de cuantos elementos se muestran -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} registros</span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalItems"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
  BCard, BTable, BAvatar, BMedia, BOverlay, BCardHeader, BCardTitle, BCardText, BRow, BCol,
  BFormInput, BInputGroup, BInputGroupPrepend, BPagination, BButton,
  BCardBody,
} from 'bootstrap-vue'
import store from '@/store'
import { useFillDataTable } from '@core/components/data-table/useFillDataTable'
import {
  avatarText, lastUpdate,
} from '@core/utils/filter'
import {
  configTableAlumnosBajas,
} from '@/views/campus/control-academico/bajas/posibles_bajas/useAluBajas'
import {
  ref, onMounted, watch, getCurrentInstance, computed,
} from '@vue/composition-api'
import vSelect from 'vue-select'

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BMedia,
    BOverlay,
    BCardHeader,
    BCardTitle,
    BCardText,
    BRow,
    BButton,
    BCol,
    vSelect,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BPagination,
    BCardBody,
  },
  setup() {
    const {
      //* Fetching data
      fetchData, refetchData, refDataListTable,
      //* Pagination
      dataMeta,
      //* Table dynamic params
      dynamicParamRequest,
      //* Basic filters & pagination
      perPage, totalItems, currentPage, perPageOptions, searchQuery, sortBy, isSortDirDesc,
      //* Loader
      isBusyTable,
      //* Error
      errorRequest,
    } = useFillDataTable()
    const updatedAt = ref(lastUpdate())
    const {
      tableColumns,
      configRequest,
      resolveAlumnoTipoVariant,
    } = configTableAlumnosBajas()

    const errorContent = ref({ filters: false, table: false })
    const vm = getCurrentInstance().proxy
    const userRole = computed(() => store.state.cuenta.rolSelected)
    const saveChanges = alumno => {
      if (alumno.item !== null) {
        const datasent = {
          periodo: alumno.item.ultimo_id_periodo,
          id_agenda: alumno.item.agenda,
          archivo_lk: null,
          tipo_baja: 'BA',
          tipo_solicitante: userRole.value.id,
        }
        store.dispatch('bajas/postDatosSol', { data: datasent })
          .then(response => {
            vm.$swal({
              icon: 'success',
              allowOutsideClick: false,
              title: 'Solicitud creada',
              html: `${response.message}`,
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            refetchData(true)
          }, error => {
            vm.$swal({
              icon: 'error',
              allowOutsideClick: false,
              title: 'Lo sentimos - error de servicio',
              html: `${error}`,
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          })
      }
    }
    const crearsolicitud = alumno => {
      vm.$swal({
        icon: 'warning',
        allowOutsideClick: false,
        title: 'Crear solicitud de baja académica',
        showCancelButton: true,
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
      }).then(result => {
        if (result.value) { saveChanges(alumno) }
      })
    }
    //* On mounted
    onMounted(() => {
      dynamicParamRequest.value = configRequest.value //* Asign config params for each module as dynamic params
      // cargar catalogos
    })

    watch(errorRequest, error => { if (error) errorContent.value.table = error }) //* If the flag 'errorRequest' from data request is true, hide table content
    watch(configRequest.value, () => { refetchData() }) //* Any change in config params (filters), refetch table data

    return {
      crearsolicitud,
      fetchData,
      tableColumns,
      perPage,
      currentPage,
      totalItems,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataListTable,
      refetchData,
      avatarText,
      isBusyTable,
      configRequest,
      resolveAlumnoTipoVariant,
      errorContent,
      updatedAt,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
